// Quality Assurance tab (B6) — shared bits. Severity uses the status
// tokens only: Observation = info, Exception = error (same condition =
// same color everywhere).

import { Badge } from "@/design-system/components/ui";
import type { QaFindingSeverity } from "@/api/portfolioAdmin/qaReviewsApi";

export function QaSeverityBadge({ severity }: { severity: QaFindingSeverity }) {
  return (
    <Badge status={severity === "Exception" ? "error" : "info"}>
      {severity}
    </Badge>
  );
}
